import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useQuantity } from "../../hooks/useQuantity";
import { addProductToCart } from "../../redux/reducers/slice/cart";
import { selectIsCheckGrandOpeningPromotion } from "../../redux/reducers/slice/common";
import {
  checkGrandOpeningPromotion,
  getKindOfBed,
  getSlugByLanguage,
} from "../../shared/helpers";
import NotificationAddToCartSuccess from "../notification";
import ProductItemComponent from "../productItem";
import WishButton from "../wishButton";
import "./productItemStyle.scss";

const ProductItem = (props: any) => {
  const { product, parentIndex, index, type } = props;
  const isCheckGrandOpeningPromotion = useSelector(
    selectIsCheckGrandOpeningPromotion
  );
  const [quantity, decreaseQuantity, increaseQuantity, resetQuantity] =
    useQuantity(1);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const handleAddToCart = async () => {
    const addToCartResponse = await dispatch(
      addProductToCart(
        { ...product, cat_id_v2: product._id, code: product.code },
        true,
        quantity
      )
    );

    if (!addToCartResponse) {
      NotificationAddToCartSuccess({
        productName: product.name,
        productFeature: product.feature?.spec,
      });

      let parentNode;

      if (type === "BOUGHT_TOGETHER") {
        parentNode = document.getElementsByClassName(
          "bought-together-product-slider"
        )[parentIndex];
      }

      if (type === "RELATED") {
        parentNode = document.getElementsByClassName("related-product-slider")[
          parentIndex
        ];
      }
      if (!parentNode) {
        return false;
      }

      return { parentNode, index };
    }

    return false;
  };

  const getProductItemProps = () => ({
    productId: product._id,
    productPath: getSlugByLanguage(product, i18n.language),
    img: product.img_id,
    name: product.name,
    featureCode: product.code,
    price: product.feature.price,
    price_promotion: product.feature.price_promotion,
    discount_percent: product.feature.discount_percent,
    price_installment: product.feature.price_installment,
    info_promotion: product.feature.info_promotion,
    quantity: quantity,
    category_name: product.category_name,
    features: {
      options: null,
      currentValue: product.feature,
      handleOnChange: null,
      is_need_dropdown_features: false,
      is_label_dropdown: false,
      is_special_category: false,
      is_hide_thick_dropdown: false,
      is_normal_dropdown: false,
    },
    covers: {
      isNeedDropdown: false,
      labelDefault: getKindOfBed(product.code),
    },
    foams: null,
    desk: null,
    isHaveMoreGift: checkGrandOpeningPromotion(
      isCheckGrandOpeningPromotion,
      product.feature.price,
      product._id
    ),
    isNeedCompare: false,
    isInCompareList: null,
    isNeedContact: product.is_need_contact,
    //  checkInCompareList(
    //   getPropertiesCompare(),
    //   compareProducts
    // ),
    addToCart: handleAddToCart,
    decreaseQuantity: decreaseQuantity,
    increaseQuantity: increaseQuantity,
    resetQuantity: resetQuantity,
    addToCompare: () => null, //handleAddToCompare,
    removeFromCompare: () => null, //handleRemoveFromCompare,
    renderWishButton: () => (
      <WishButton
        {...props}
        feature={{ value: product.code, wish: product.wish }}
      />
    ),
  });

  return <ProductItemComponent {...getProductItemProps()} />;
};

export default ProductItem;
